document.querySelectorAll('.date-column').forEach(function(dateEl) {
  // Get the full text, e.g., "October 9, 2025 (Fri)"
  let dateText = dateEl.textContent.trim();

  // Parse the date (JS Date object ignores the weekday in parentheses)
  let cellDate = new Date(dateText);

  // Proceed only if the date is valid
  if (isNaN(cellDate.getTime())) return;

  // Normalize both dates to midnight
  let today = new Date();
  cellDate.setHours(0,0,0,0);
  today.setHours(0,0,0,0);

  // If the date is in the past
  if (cellDate < today) {
    // Extract the element's id
    let targetId = dateEl.id || dateEl.getAttribute('id');
    if (!targetId) return;

    // Hide all elements that have this id in their class list
    document.querySelectorAll(`.${targetId}`).forEach(function(el) {
      el.style.display = 'none';
    });
  }
});